import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button } from "@mui/material";
import { useAuth } from "./index.js";
export const AdminButton = ({ children, buttonProps: { sx = [], ...buttonProps }, sx: boxSx = [], ...props }) => {
    const { isFedAdmin } = useAuth();
    if (!isFedAdmin) {
        return children;
    }
    return (_jsxs(Box, { ...props, sx: [
            { position: "relative" },
            ...(Array.isArray(boxSx) ? boxSx : [boxSx]),
        ], children: [_jsx(Button, { variant: "contained", size: "small", sx: [
                    {
                        position: "absolute",
                        top: ({ spacing }) => spacing(3),
                        right: ({ spacing }) => spacing(-2.5),
                        px: 0.5,
                        minWidth: 0,
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                    },
                    ...(Array.isArray(sx) ? sx : [sx]),
                ], ...buttonProps }), _jsx(Box, { sx: { position: "relative" }, children: children })] }));
};
//# sourceMappingURL=AdminButton.js.map